<template>
  <div class="doExam"
       v-loading.fullscreen="commitStatus">
    <div v-show="!isVisibleScreen">
      <div id="my-calculator"
           style="display: none;"></div>
      <div class="ques-head">
        <span class="name">{{ $categoryInfo.category }}资格全国统一考试</span>
        <div class="head-r">
          <ul>
            <li v-if="isStart" class="fontSize">
              <template v-if="isShowFontSize">
                <span class="zt" @click="isShowFontSize=!isShowFontSize"></span>
              </template>
              <template v-else>
                <el-tooltip effect="dark" content="字号调节" placement="bottom">
                  <span class="zt" @click="isShowFontSize=!isShowFontSize"></span>
                </el-tooltip>
              </template>
              <div class="pr"
                   v-show="isShowFontSize">
                <div class="font-btns">
                  <span class="arrow"></span>
                  <b class="btn fl"
                     @click="changeFontSizeS">-</b>
                  <span class="zoom-val">{{ currentSize }}</span>
                  <b class="btn fr"
                     @click="changeFontSizeB">+</b>
                </div>
              </div>
            </li>
            <li class="pro">
              <el-tooltip effect="dark"
                          content="收起答题进度"
                          placement="bottom"
                          v-show="isShowProgress">
                <el-button @click="isShowProgress=!isShowProgress">已答{{
                    quesNum - unAnswerLen
                  }}/{{ quesNum }}题
                </el-button>
              </el-tooltip>
              <el-tooltip effect="dark"
                          content="展开答题进度"
                          placement="bottom"
                          v-show="!isShowProgress">
                <div @click="isShowProgress=!isShowProgress">
                  <img src="@/assets/images/doExam/icon-pro.png"
                       alt="">
                </div>
              </el-tooltip>
            </li>
            <li class="time"
                v-if="endTimes>0">
              <!--答题区倒计时-->
              <el-tooltip effect="dark"
                          content="收起剩余时间"
                          placement="bottom"
                          v-show="isShowTime">
                <el-button @click="isShowTime=!isShowTime">
                  <timer v-if="endTimes>0"
                         :end-times.sync="endTimes"
                         ref="countDown"/>
                </el-button>
              </el-tooltip>
              <el-tooltip effect="dark"
                          content="展开剩余时间"
                          placement="bottom"
                          v-show="!isShowTime">
                <div @click="isShowTime=!isShowTime"><img src="@/assets/images/doExam/icon-time.png"
                                                          alt=""></div>
              </el-tooltip>
            </li>
            <li class="leave">
              <button class="leave-btn"
                      @click="cancelTimer">‖ 暂离锁屏
              </button>
            </li>
            <li class="seat-num-block">
              <span>座位号 </span>
              <span class="seat-num">1</span>
            </li>
          </ul>
        </div>
      </div>
      <!--启动页-->
      <exam-start-page v-if="!isStart && !isStartChoose"
                       :currentCourse="currentCourse"
                       @showExamPage="showExamPage"></exam-start-page>
      <!-- 题目进入页 -->
      <exam-choose-page v-if="!isStart && isStartChoose"
                        :courseName="courseName"
                        @showExamPage="showExamPage"
                        @examStart="examStart"
                        @zhAutoExam="isZhAutoExamFun"
      ></exam-choose-page>
      <div v-if="isStart && !isStartChoose"
           class="ques-content">
        <div class="item-list"
             :style="'left:' + examListLeft">
          <div class="item-list-cont">
            <button :class="[{'folder':!showLeftInfo},'btn-folder']"
                    @click="foldLeft"></button>
            <div class="wrap-list-top">
              <div class="wrap-user-info">
                <div class="user-photo"
                     @click="userShowUpFun">
                  <img src="@/assets/images/doExam//photo-d.png"
                       alt=""
                       class="default">
                  <span><i :class="{'up':this.userShowUp}"></i></span>
                </div>
                <div class="entry-info"
                     v-show="!this.userShowUp">
                  <ul>
                    <li><span class="s1">性名：</span><span class="s2">演示</span></li>
                    <li><span class="s1">性别：</span><span class="s2">男</span></li>
                    <li><span class="s1">准考证号：</span><span class="s2">{{ zkzID }}</span></li>
                    <li><span class="s1">证件号码：</span><span class="s2">320321********4904</span></li>
                    <li><span class="s1">考试科目：</span><span class="s2">{{ courseName }}</span></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="wrap-item-num-list"
                 :style="'top:' + examListTop">
              <exam-ques-list :courseName="courseName"
                              @quesFn="changeByQueListFun"></exam-ques-list>
            </div>
            <div class="item-note">
              <ul class="item-note-list">
                <li>
                  <div class="current"><span class="num-val"></span></div>
                  <div>当前</div>
                </li>
                <li>
                  <div class="undo"><span class="num-val"></span></div>
                  <div>未完成</div>
                </li>
                <li>
                  <div class="dopart"><span class="num-val"></span></div>
                  <div>部分完成</div>
                </li>
                <li>
                  <div class="done"><span class="num-val"></span></div>
                  <div>已完成</div>
                </li>
                <li>
                  <div class="marked"><span class="num-val"></span></div>
                  <div>标记</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="item-con"
             :style="{left:wrapQuesLeft}">
          <div class="wrap-group-name"
               v-if="quesTypeShowMap && quesTypeShowMap[currentQuestion.relOrder]"
               ref="quesShowName"
               :class="(currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5)?'on':''">
            <div class="group-name">
              {{
                quesTypeShowMap[currentQuestion.relOrder].showSerialNum
              }}、{{ quesTypeShowMap[currentQuestion.relOrder].viewTypeName }}
            </div>
            <div class="group-description">
              {{
                quesTypeShowMap[currentQuestion.relOrder].quesTypeDesc ? '(' + quesTypeShowMap[currentQuestion.relOrder].quesTypeDesc + ')' : ''
              }}
            </div>
            <language-box v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5"></language-box>
          </div>
          <div class="wrap-ques"
               :style="{fontSize: mainSize,top:mainQuesTop}">
            <!-- 单选题、判断题 -->
            <template v-if="currentQuestion.quesTypeID === 1 || currentQuestion.quesTypeID === 3">
              <exam-single-choice/>
            </template>
            <!-- 多选题 -->
            <template v-if="currentQuestion.quesTypeID === 2">
              <exam-multiple-choice/>
            </template>
            <!-- 简答题、综合题、计算分析题(大题套小题，文字题) -->
            <template v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
              <!-- 包含子题目 -->
              <template v-if="currentQuestion.smallContent && currentQuestion.smallContent.length > 0">
                <has-child-question ref="hasChildQuestion"
                                    @runCalc="runCalc"
                                    @setCurrentSmallContentFn="setCurrentSmallContentFn"
                                    :isShowLeftInfo="showLeftInfo"/>
              </template>
              <!-- 不包含子题目 -->
              <template v-else>
                <without-child-question ref="withoutChildQuestion"
                                        @runCalc="runCalc"
                                        @setCurrentSmallContentFn="setCurrentSmallContentFn"/>
              </template>
            </template>
          </div>
        </div>
      </div>
      <div v-if="isStart && !isStartChoose"
           class="ques-footer clearfix">
        <div class="l-btn">
          <a href="javascript:void (0)"
             @click="handOverFn"
             class="submitbutton">交卷</a>
          <a href="javascript:void (0)"
             @click="markToggleFn"
             class="markbutton"
             :class="[{'markbuttonCancel':currentQuestion.isMark===1}, 'markbutton']"
             v-html="(currentQuestion.isMark===1)?'取消标记':'标记本题'"></a>
        </div>
        <div class="r-btn">
          <a href="javascript:void (0)"
             @click="computers"
             class="calbutton">计算器</a>
          <a v-if="isShowAnswer"
             href="javascript:void (0)"
             @click="toggleAnswer(true)"
             class="calbutton">参考答案</a>
          <a v-if="isShowTable"
             href="javascript:void (0)"
             class="calbutton"
             @click="toggleTable(true)">系数表</a>
          <!--          <a v-if="isShowTableTaxLaw"
                       href="javascript:void (0)"
                       class="calbutton"
                       @click="toggleTableTaxLaw(true)">税率表</a>-->
          <!--上一步-->
          <a v-show="preDisabled"
             href="javascript:void (0)"
             @click="changeQues('prevPage')"
             class="preBtn"><i></i> 上一页</a>
          <!--做题上下-->
          <a v-show="!preDisabled"
             href="javascript:void (0)"
             @click="changeQues('prev')"
             :class="[{ preDisabled: preDisabled }, 'preBtn']"
             :disabled="preDisabled"><i></i> 上一页</a>
          <a v-show="!nextDisabled"
             href="javascript:void (0)"
             @click="changeQues('next')"
             :class="[{ nextDisabled: nextDisabled }, 'nextBtn']"
             :disabled="nextDisabled">下一页 <i></i></a>
        </div>
      </div>
    </div>
    <div class="custom-modal simulation-modal" v-if="computer">
      <div class="modal-alert">
        <div class="custom-modal-header">
          <div>提示</div>
        </div>
        <div class="custom-modal-body">
          <p>本计算器为仿真模拟。</p>
          <p>如需演练计算器，请您调用操作系统下自带计算器进行练习。</p>
        </div>
        <div class="custom-modal-footer">
          <button id="simulation_confirm_btn" class="yk-btn-primary" type="button" @click="runCalc" style="">确认</button>
        </div>
      </div>
    </div>
    <!--锁屏界面-->
    <leave-screen :mes="endTimes"
                  :visible="isVisibleScreen"
                  :zkzIdDefault="zkzID"
                  @closeScreen="goOnTimer"></leave-screen>
    <!---->
    <submit-alert :visible.sync="visibleAlert"
                  :unAnswerCount="unAnswerLen"
                  :multi-status.sync="multiStatus"
                  @submit="endToSave"></submit-alert>

    <exam-end :visible.sync="endExamFlag"
              :isHaveSubjective="isHaveSubjective"
              :is-ai="aiScoring.isAI"
              :is-ai-finished="aiScoring.finished"
              @viewResults="viewResults"
              @subjectiveQuestionsStore="subjectiveQuestionsStore"></exam-end>

    <!--给主观题打分-->
    <subjective-mark :visible="visibleSub"
                     :questionsMap="questionsMap"
                     @close="closeSubjective"
                     @submit="submitSub"/>
    <!-- 系数表 -->

    <exam-table v-if="isVisibleTable"
                @toggleTable="toggleTable"/>
    <!-- 税率表 -->
    <exam-table-tax-law v-if="isVisibleTableTaxLaw"
                        @toggleTable="toggleTableTaxLaw"/>
    <!-- 参考答案 -->
    <ques-answer-list v-if="isVisibleAnswer"
                      @toggleTable="toggleAnswer"/>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {
  Timer,
  ExamQuesList,
  ExamSingleChoice,
  ExamMultipleChoice,
  examEnd,
  subjectiveMark,
  hasChildQuestion,
  withoutChildQuestion,
  submitAlert,
  leaveScreen,
  ExamTable,
  ExamTableTaxLaw,
  ExamStartPage,
  ExamChoosePage,
  QuesAnswerList,
  LanguageBox,
} from '@components/exam'

import mixin from '@/mixins/exam'
import mixinCl from '@/mixins/checkLogged'
import {parseNumber, getCookie} from '@/utils'

window._calc_element = 'my-calculator'

export default {
  name: 'DoExam',
  components: {
    Timer,
    ExamQuesList,
    ExamMultipleChoice,
    ExamSingleChoice,
    examEnd,
    subjectiveMark,
    hasChildQuestion,
    withoutChildQuestion,
    submitAlert,
    leaveScreen,
    ExamTable,
    ExamTableTaxLaw,
    ExamStartPage,
    ExamChoosePage,
    QuesAnswerList,
    LanguageBox,
  },
  computed: {
    ...mapGetters(['currentQuestionIndex', 'currentQuestion']),
  },
  mixins: [mixin, mixinCl],
  data() {
    return {
      computer:false,
      currentCourse: null,
      isStart: false, // 是否开始做题
      isStartChoose: false, // 是否展示选择题页面
      isVisibleAnswer: false, // 答案弹框
      isShowAnswer: false, //是否显示答案项
      //基础参数
      siteCourseID: 0, //课程ID
      courseID: 0,
      courseName: '', //课程名称
      flag: '', //考试类型
      majorID: 0, //辅导ID
      temp: '', //试卷类型（1，新试卷  2，未完成试卷）
      bizID: '', //试卷ID
      spendTime: 0, //试卷消耗时间
      uid: '', //用户ID
      endTimes: 0,
      timer: null, //计时器
      endExamFlag: false, //结束考试弹框
      visibleAlert: false, //提交试卷弹框
      // tenMinutesFlag: false, //十分钟倒计时弹框
      visibleSub: false, //主观题评分弹框
      isHaveSubjective: true, //是否含有主观题
      alertWindow: {
        // 交卷弹窗
        show: false,
        courseName: '',
        unAnswerCount: 0,
        allQuestions: 0,
        isMultipleSelection: false, // 是否多选题只选了一个答案
      },
      questionsMap: [],
      paperRedo: null, //是否是试题重做
      zkzID: '1234',
      userName: '', //用户名
      commitStatus: false, // 提交接口 执行状态
      multiStatus: false, //alert组件是否显示多选提示
      isShowProgress: true, //是否展示答题进度
      isShowTime: true, //是否展示剩余时间
      userShowUp: false, //学生信息展开收起
      showLeftInfo: true, //左边题型列表展开收起
      isShowFontSize: false, //调节字体框展开收起
      mainSize: '16px',
      currentSize: '中',
      isVisibleScreen: false, //锁屏界面显隐
      examListTop: '270px',
      wrapQuesLeft: '230px',
      examListLeft: '',
      // stopTime: 0,
      mainQuesTop: '', //题组件距离顶部高度
      // visibleMatrixTip:true, //矩阵提示弹框
      // 系数表等按钮
      isShowTable: false, //是否显示系数表按钮
      isShowTableTaxLaw: false, //是否显示税法表按钮
      isVisibleTable: false, //系数表弹框
      isVisibleTableTaxLaw: false, //税法表弹框
      isZhAutoExam: false  //是否综合自动开始做题
    }
  },
  watch: {
    endTimes(newVal) {
      document.title = this.timeFilter(newVal)
      if (newVal === 15) {
        clearInterval(this.timer)
      }
      if (!this.endExamFlag && newVal === 0) {
        this.endToSubmit()
      }
    },
    currentQuestion: {
      handler(newVal, oldVal) {
        if (newVal.content !== oldVal.content) {
          this.getHeight()
        }
      },
      deep: true,
    },
  },
  async mounted() {
    const {flag} = this.$route.params
    const {
      siteCourseID,
      temp,
      bizID = '',
      spendTime = 0,
      courseID,
      paperRedo,
      zkzID,
    } = this.$route.query
    const {majorID} = this.$categoryInfo
    this.flag = flag === 'paidExam' ? '' : flag
    this.majorID = majorID
    this.zkzID = zkzID || '1234'
    this.paperRedo = Number(paperRedo)
    this.courseID = Number(courseID)
    if (this.courseID === 276) {
      this.isShowTable = true
    } else if (this.courseID === 273) {
      // 20220401 教务需求不再显示税率表，此功能暂时注释掉
      // this.isShowTableTaxLaw = true
    } else if (this.courseID === 357) {
      this.isShowTable = true
      // this.isShowTableTaxLaw = true
    }
    this.siteCourseID = parseNumber(siteCourseID)
    this.temp = parseNumber(temp)
    this.bizID = parseNumber(bizID)
    this.spendTime = Number(spendTime)
    this.uid = parseNumber(getCookie('cdeluid') || '')
    this.userName = getCookie('username') || ''
    await this.initExam()

    //计算器实例化
    let that = this
    this.$nextTick(() => {
      window.SetCalcType()
      window.addEventListener('resize', that.getHeight)
    })
  },
  methods: {
    computers(){
      this.computer = true;
    },
    getHeight() {
      this.$nextTick(() => {
        if (this.$refs.quesShowName) {
          this.mainQuesTop = this.$refs.quesShowName.offsetHeight + 'px'
          this.$forceUpdate()
        }
      })
    },
    foldLeft() {
      if (this.showLeftInfo) {
        this.showLeftInfo = false
        this.wrapQuesLeft = '10px'
        this.examListLeft = '-220px'
        this.$forceUpdate()
      } else {
        this.showLeftInfo = true
        this.wrapQuesLeft = '230px'
        this.examListLeft = 0
        this.$forceUpdate()
      }
    },
    //暂离锁屏
    cancelTimer() {
      this.isVisibleScreen = true
      // this.$refs.countDown.stopTimer()
      // this.stopTime = this.endTimes
    },
    //关闭锁屏界面
    goOnTimer() {
      this.isVisibleScreen = false
      // this.$refs.countDown.setTime()
      // this.stopTime = 0
    },
    userShowUpFun() {
      if (this.userShowUp) {
        this.userShowUp = false
        this.examListTop = '270px'
      } else {
        this.userShowUp = true
        this.examListTop = '150px'
      }
    },
    //字体调节
    changeFontSizeS() {
      //this.mainSize = `${size}px`
      if (this.mainSize == '18px') {
        this.mainSize = '16px'
        this.currentSize = '中'
      } else if (this.mainSize == '16px') {
        this.mainSize = '14px'
        this.currentSize = '小'
      }
    },
    changeFontSizeB() {
      if (this.mainSize == '14px') {
        this.mainSize = '16px'
        this.currentSize = '中'
      } else if (this.mainSize == '16px') {
        this.mainSize = '18px'
        this.currentSize = '大'
      }
    },
  },
}
</script>


